/* tslint:disable */
/* eslint-disable */
/**
 * Y-Sports backend-next Management API
 * Composed management-facing contract for `backend-next`. This spec is an aggregation layer over module-scoped contracts and should reference canonical module definitions instead of copying them. 
 *
 * The version of the OpenAPI document: 0.1.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { mapValues } from '../runtime';
import type { TournamentRegistrationFieldPreference } from './TournamentRegistrationFieldPreference';
import {
    TournamentRegistrationFieldPreferenceFromJSON,
    TournamentRegistrationFieldPreferenceFromJSONTyped,
    TournamentRegistrationFieldPreferenceToJSON,
    TournamentRegistrationFieldPreferenceToJSONTyped,
} from './TournamentRegistrationFieldPreference';

/**
 * Omitted endDate preserves the current end date; single-day tournaments follow a changed start date.
 * @export
 * @interface TournamentUpdateRequest
 */
export interface TournamentUpdateRequest {
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    name?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    location?: string;
    /**
     * 
     * @type {Date}
     * @memberof TournamentUpdateRequest
     */
    date?: Date;
    /**
     * 
     * @type {Date}
     * @memberof TournamentUpdateRequest
     */
    endDate?: Date;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    description?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    locationUrl?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    infoUrl?: string;
    /**
     * 
     * @type {number}
     * @memberof TournamentUpdateRequest
     */
    latitude?: number;
    /**
     * 
     * @type {number}
     * @memberof TournamentUpdateRequest
     */
    longitude?: number;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    matchmakingMode?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    matchOperationsMode?: string;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    matchOperationsRulesetCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    publicLiveFeedEnabled?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    overlayFeedEnabled?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    overlayThemeCode?: string;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    isInvitationOnly?: boolean;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentUpdateRequest
     */
    invitedEmails?: Array<string>;
    /**
     * 
     * @type {Array<TournamentRegistrationFieldPreference>}
     * @memberof TournamentUpdateRequest
     */
    registrationFieldPreferences?: Array<TournamentRegistrationFieldPreference>;
    /**
     * 
     * @type {Array<string>}
     * @memberof TournamentUpdateRequest
     */
    allowedCountries?: Array<string>;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    allowPaymentReceiptUpload?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    showTeamsTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    showScheduleTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    showResultsTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    showStructureTab?: boolean;
    /**
     * 
     * @type {boolean}
     * @memberof TournamentUpdateRequest
     */
    showClassificationTab?: boolean;
    /**
     * 
     * @type {string}
     * @memberof TournamentUpdateRequest
     */
    tournamentStatus?: string;
}

/**
 * Check if a given object implements the TournamentUpdateRequest interface.
 */
export function instanceOfTournamentUpdateRequest(value: object): value is TournamentUpdateRequest {
    return true;
}

export function TournamentUpdateRequestFromJSON(json: any): TournamentUpdateRequest {
    return TournamentUpdateRequestFromJSONTyped(json, false);
}

export function TournamentUpdateRequestFromJSONTyped(json: any, ignoreDiscriminator: boolean): TournamentUpdateRequest {
    if (json == null) {
        return json;
    }
    return {
        
        'name': json['name'] == null ? undefined : json['name'],
        'location': json['location'] == null ? undefined : json['location'],
        'date': json['date'] == null ? undefined : (new Date(json['date'])),
        'endDate': json['endDate'] == null ? undefined : (new Date(json['endDate'])),
        'description': json['description'] == null ? undefined : json['description'],
        'locationUrl': json['locationUrl'] == null ? undefined : json['locationUrl'],
        'infoUrl': json['infoUrl'] == null ? undefined : json['infoUrl'],
        'latitude': json['latitude'] == null ? undefined : json['latitude'],
        'longitude': json['longitude'] == null ? undefined : json['longitude'],
        'matchmakingMode': json['matchmakingMode'] == null ? undefined : json['matchmakingMode'],
        'matchOperationsMode': json['matchOperationsMode'] == null ? undefined : json['matchOperationsMode'],
        'matchOperationsRulesetCode': json['matchOperationsRulesetCode'] == null ? undefined : json['matchOperationsRulesetCode'],
        'publicLiveFeedEnabled': json['publicLiveFeedEnabled'] == null ? undefined : json['publicLiveFeedEnabled'],
        'overlayFeedEnabled': json['overlayFeedEnabled'] == null ? undefined : json['overlayFeedEnabled'],
        'overlayThemeCode': json['overlayThemeCode'] == null ? undefined : json['overlayThemeCode'],
        'isInvitationOnly': json['isInvitationOnly'] == null ? undefined : json['isInvitationOnly'],
        'invitedEmails': json['invitedEmails'] == null ? undefined : json['invitedEmails'],
        'registrationFieldPreferences': json['registrationFieldPreferences'] == null ? undefined : ((json['registrationFieldPreferences'] as Array<any>).map(TournamentRegistrationFieldPreferenceFromJSON)),
        'allowedCountries': json['allowedCountries'] == null ? undefined : json['allowedCountries'],
        'allowPaymentReceiptUpload': json['allowPaymentReceiptUpload'] == null ? undefined : json['allowPaymentReceiptUpload'],
        'showTeamsTab': json['showTeamsTab'] == null ? undefined : json['showTeamsTab'],
        'showScheduleTab': json['showScheduleTab'] == null ? undefined : json['showScheduleTab'],
        'showResultsTab': json['showResultsTab'] == null ? undefined : json['showResultsTab'],
        'showStructureTab': json['showStructureTab'] == null ? undefined : json['showStructureTab'],
        'showClassificationTab': json['showClassificationTab'] == null ? undefined : json['showClassificationTab'],
        'tournamentStatus': json['tournamentStatus'] == null ? undefined : json['tournamentStatus'],
    };
}

export function TournamentUpdateRequestToJSON(json: any): TournamentUpdateRequest {
    return TournamentUpdateRequestToJSONTyped(json, false);
}

export function TournamentUpdateRequestToJSONTyped(value?: TournamentUpdateRequest | null, ignoreDiscriminator: boolean = false): any {
    if (value == null) {
        return value;
    }

    return {
        
        'name': value['name'],
        'location': value['location'],
        'date': value['date'] == null ? value['date'] : value['date'].toISOString().substring(0,10),
        'endDate': value['endDate'] == null ? value['endDate'] : value['endDate'].toISOString().substring(0,10),
        'description': value['description'],
        'locationUrl': value['locationUrl'],
        'infoUrl': value['infoUrl'],
        'latitude': value['latitude'],
        'longitude': value['longitude'],
        'matchmakingMode': value['matchmakingMode'],
        'matchOperationsMode': value['matchOperationsMode'],
        'matchOperationsRulesetCode': value['matchOperationsRulesetCode'],
        'publicLiveFeedEnabled': value['publicLiveFeedEnabled'],
        'overlayFeedEnabled': value['overlayFeedEnabled'],
        'overlayThemeCode': value['overlayThemeCode'],
        'isInvitationOnly': value['isInvitationOnly'],
        'invitedEmails': value['invitedEmails'],
        'registrationFieldPreferences': value['registrationFieldPreferences'] == null ? undefined : ((value['registrationFieldPreferences'] as Array<any>).map(TournamentRegistrationFieldPreferenceToJSON)),
        'allowedCountries': value['allowedCountries'],
        'allowPaymentReceiptUpload': value['allowPaymentReceiptUpload'],
        'showTeamsTab': value['showTeamsTab'],
        'showScheduleTab': value['showScheduleTab'],
        'showResultsTab': value['showResultsTab'],
        'showStructureTab': value['showStructureTab'],
        'showClassificationTab': value['showClassificationTab'],
        'tournamentStatus': value['tournamentStatus'],
    };
}

